// 指定文件名下载
export const customFileName = (fileUrl, fileName, fileExt) => {
    let downloadFileName = '';
    if (fileName.search('.' + fileExt) !== -1) {
        downloadFileName = fileName;
    } else {
        downloadFileName = fileName + '.' + fileExt;
    }

    fetch(fileUrl).then((res) =>
        res.blob().then((blob) => {
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = downloadFileName;
            a.click();
            window.URL.revokeObjectURL(url);
        })
    );
};
